<template>
  <v-layout row justify-start pt-3 pb-2 @click="clicked" class="pointer">
      <v-layout style="overflow: hidden;flex: 0 0 auto;">
        <v-flex class="prevent-overflow px-2" >
          <img ref="studentPhoto" v-bind:src="chart.imageUrl" class="img-size" />
        </v-flex>
      </v-layout>
      <v-layout>
        <div class="prevent-overflow" style="overflow: hidden">
            <span class="chart-title">
              {{title}}
            </span>
          <span class="chart-description">
              {{description}}
            </span>
        </div>
      </v-layout>
  </v-layout>
</template>

<script>
  import { mapActions, mapMutations } from 'vuex'
  import { GET_CHART_FOR_STAFF, SET_UNDO_STATE_ASYNC } from '../../store/action-types'
  import {
    DASHBOARD_CHARTS_NOT_CACHED, SET_CHART_UPDATED,
    SET_INFORMATION_SNACKBAR_STATE,
    SET_INFORMATION_SNACKBAR_TEXT
  } from '../../store/mutation-types'
  import { informationTexts } from '../../store/modules/information'

  export default {
    name: 'chart-row',
    props: {
      chart: {
        type: Object,
        required: true
      },
      dialog: {
        type: Function
      }
    },
    computed: {
      title () {
        let key = `dashboard.chart.${this.chart.id}.title`
        let defaultKey = `dashboard.chart.default.title`
        if (this.$i18n.keyExists(key)) {
          return this.$t(key)
        } else {
          return this.$t(defaultKey)
        }
      },
      description () {
        let key = `dashboard.chart.${this.chart.id}.description`
        let defaultKey = `dashboard.chart.default.description`
        if (this.$i18n.keyExists(key)) {
          return this.$t(key)
        } else {
          return this.$t(defaultKey)
        }
      }
    },
    methods: {
      ...mapActions({
        getChartForStaff: GET_CHART_FOR_STAFF,
        setUndoSnackBar: SET_UNDO_STATE_ASYNC
      }),
      ...mapMutations({
        setSnackBarText: SET_INFORMATION_SNACKBAR_TEXT,
        setSnackBar: SET_INFORMATION_SNACKBAR_STATE,
        unCacheCharts: DASHBOARD_CHARTS_NOT_CACHED,
        setChartUpdated: SET_CHART_UPDATED
      }),
      clicked () {
        this.setChartUpdated(false)
        this.unCacheCharts()
        this.getChartForStaff({chartId: this.chart.id})
        this.dialog()
        this.setSnackBarText(informationTexts.CHART_CREATED)
        this.setSnackBar(true)
      }
    }
  }
</script>


<style scoped>
  .chart-title {
    font-size: 16px;
    font-weight: bolder;
    text-align: center;
  }
  .chart-description {
    display: block;
  }
  .img-size {
    width: 80px;
  }
  @media only screen and (max-width: 599px) {
    .img-size {
      width: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/ChartRow.vue